import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagEE = function FlagEE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#000",
    d: "M0 25c0 3.058.55 5.987 1.555 8.695L25 34.782l23.445-1.087A24.945 24.945 0 0 0 50 25c0-3.058-.55-5.988-1.555-8.696L25 15.217 1.555 16.304A24.947 24.947 0 0 0 0 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M25 0C14.25 0 5.087 6.784 1.555 16.304h46.89C44.912 6.784 35.749 0 25 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M48.445 33.696H1.555C5.087 43.216 14.25 50 25 50s19.912-6.785 23.445-16.304Z"
  }));
};
FlagEE.displayName = 'FlagEE';
export default withFlagWrapper(FlagEE);
//# sourceMappingURL=index.js.map